import { render, staticRenderFns } from "./update-password.vue?vue&type=template&id=9d535ac4&scoped=true"
import script from "./update-password.vue?vue&type=script&lang=js"
export * from "./update-password.vue?vue&type=script&lang=js"
import style0 from "./update-password.vue?vue&type=style&index=0&id=9d535ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d535ac4",
  null
  
)

export default component.exports